import React from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { selectDocumentPublishedStatus } from '@redux/documents/reducers';
import PublishedStatusIcon from '@components/PublishedStatusIcon';

function PublishedStatusColumn({ documentId }) {
  const published = useSelector(selectDocumentPublishedStatus(documentId));

  if (published === undefined) return <Spin />;

  return <PublishedStatusIcon published={published} />;
}

export default PublishedStatusColumn;
